import { VoucherService } from './../../../service/voucherService/voucher.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FileUploadService } from './../../../file-upload.service';
import { OfferService } from './../../../service/offers/offer.service';
import { MatOption } from '@angular/material/core';
import { FileUpload } from './../../../service/FileUpload/fileUpload';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-edit-voucher',
  templateUrl: './edit-voucher.component.html',
  styleUrls: ['./edit-voucher.component.scss']
})
export class EditVoucherComponent implements OnInit {
  members:any;
  addForm:any;
  msg1:string;currentUpload:any;
msg="enter valid";fix:any;
all:boolean=false;
editId:any;
    constructor(private route:Router,private ApiService:VoucherService,private ActiveRoute:ActivatedRoute) {

      this.addForm={
        status:true,
        image:{url:""}
      }
this.editId=this.ActiveRoute.snapshot.paramMap.get('id')
this.getVoucherDetail()
     }
     

  ngOnInit(): void {
  }
 getVoucherDetail()
 {
   this.ApiService.getVoucherDetail(this.editId).then((res)=>
   {
     this.addForm=res
     console.log(this.addForm)
   })
 }
  paymentChange(education1) {
   
   

    console.log(education1);
   this.addForm.paymentOption=education1;
   console.log(this.addForm);
  }
  offerChange(education1) {
   console.log(education1);
   this.addForm.offerCode=education1;
   console.log(this.addForm);
  }
  
  EditVoucher()
  {
   this.ApiService.EditVoucherDetail(this.editId,this.addForm).then((res)=>
   {
     this.route.navigate(['dashboard/voucherList'])
   })

  console.log(this.addForm);
    }
  }